import { Alert, Box, Paper, Stack, Typography } from '@mui/material';

export interface TranscriptMessage {
  id: number | string;
  author: string;
  content: string;
  timestamp: Date;
  own: boolean;
}
export default function ChatTranscript({
  messages,
  emptyText = 'No messages yet.',
  timeZone,
}: {
  messages: TranscriptMessage[];
  emptyText?: string;
  timeZone?: string;
}) {
  return (
    <Stack role="log" aria-label="Chat messages" aria-live="polite" spacing={2} sx={{ minWidth: 0 }}>
      {messages.length === 0 && <Alert severity="info">{emptyText}</Alert>}
      {messages.map((message) => (
        <Paper
          key={message.id}
          component="article"
          variant="outlined"
          sx={{
            p: 2,
            maxWidth: '100%',
            minWidth: 0,
            alignSelf: message.own ? 'flex-end' : 'flex-start',
            bgcolor: message.own ? 'surfaces.surfaceBase' : 'surfaces.surfaceRaised',
            color: 'text.primary',
          }}
        >
          <Stack direction="row" useFlexGap flexWrap="wrap" gap={1} justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography variant="body2" fontWeight={600}>
              {message.author}
            </Typography>
            <Typography
              component="time"
              dateTime={message.timestamp.toISOString()}
              variant="caption"
              color="text.secondary"
            >
              {message.timestamp.toLocaleString(undefined, { timeZone })}
            </Typography>
          </Stack>
          <Box sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{message.content}</Box>
        </Paper>
      ))}
    </Stack>
  );
}
